export var ProjectType;
(function (ProjectType) {
    ProjectType["DEFAULT"] = "DEFAULT";
    ProjectType["PREVIEW"] = "PREVIEW";
})(ProjectType || (ProjectType = {}));
export var DbtProjectType;
(function (DbtProjectType) {
    DbtProjectType["DBT"] = "dbt";
    DbtProjectType["DBT_CLOUD_IDE"] = "dbt_cloud_ide";
    DbtProjectType["GITHUB"] = "github";
    DbtProjectType["GITLAB"] = "gitlab";
    DbtProjectType["BITBUCKET"] = "bitbucket";
    DbtProjectType["AZURE_DEVOPS"] = "azure_devops";
    DbtProjectType["NONE"] = "none";
    DbtProjectType["MANIFEST"] = "manifest";
})(DbtProjectType || (DbtProjectType = {}));
export var WarehouseTypes;
(function (WarehouseTypes) {
    WarehouseTypes["BIGQUERY"] = "bigquery";
    WarehouseTypes["POSTGRES"] = "postgres";
    WarehouseTypes["REDSHIFT"] = "redshift";
    WarehouseTypes["SNOWFLAKE"] = "snowflake";
    WarehouseTypes["DATABRICKS"] = "databricks";
    WarehouseTypes["TRINO"] = "trino";
})(WarehouseTypes || (WarehouseTypes = {}));
export var BigqueryAuthenticationType;
(function (BigqueryAuthenticationType) {
    BigqueryAuthenticationType["SSO"] = "sso";
    BigqueryAuthenticationType["PRIVATE_KEY"] = "private_key";
    BigqueryAuthenticationType["ADC"] = "adc";
})(BigqueryAuthenticationType || (BigqueryAuthenticationType = {}));
export const sensitiveCredentialsFieldNames = [
    'user',
    'password',
    'keyfileContents',
    'personalAccessToken',
    'privateKey',
    'privateKeyPass',
    'sshTunnelPrivateKey',
    'sslcert',
    'sslkey',
    'sslrootcert',
];
// TODO use enum instead
export var SnowflakeAuthenticationType;
(function (SnowflakeAuthenticationType) {
    SnowflakeAuthenticationType["PASSWORD"] = "password";
    SnowflakeAuthenticationType["PRIVATE_KEY"] = "private_key";
    SnowflakeAuthenticationType["SSO"] = "sso";
})(SnowflakeAuthenticationType || (SnowflakeAuthenticationType = {}));
export const maybeOverrideWarehouseConnection = (connection, overrides) => {
    const isBigquery = connection.type === WarehouseTypes.BIGQUERY;
    const overridesSchema = isBigquery
        ? { dataset: overrides.schema }
        : { schema: overrides.schema };
    return {
        ...connection,
        ...(overrides.schema ? overridesSchema : undefined),
    };
};
export var SupportedDbtVersions;
(function (SupportedDbtVersions) {
    SupportedDbtVersions["V1_4"] = "v1.4";
    SupportedDbtVersions["V1_5"] = "v1.5";
    SupportedDbtVersions["V1_6"] = "v1.6";
    SupportedDbtVersions["V1_7"] = "v1.7";
    SupportedDbtVersions["V1_8"] = "v1.8";
    SupportedDbtVersions["V1_9"] = "v1.9";
    SupportedDbtVersions["V1_10"] = "v1.10";
})(SupportedDbtVersions || (SupportedDbtVersions = {}));
// Make it an enum to avoid TSOA errors
export var DbtVersionOptionLatest;
(function (DbtVersionOptionLatest) {
    DbtVersionOptionLatest["LATEST"] = "latest";
})(DbtVersionOptionLatest || (DbtVersionOptionLatest = {}));
export const getLatestSupportDbtVersion = () => {
    const versions = Object.values(SupportedDbtVersions);
    return versions[versions.length - 1];
};
export const DefaultSupportedDbtVersion = DbtVersionOptionLatest.LATEST;
export const isGitProjectType = (connection) => [
    DbtProjectType.GITHUB,
    DbtProjectType.GITLAB,
    DbtProjectType.BITBUCKET,
].includes(connection.type);
const isRemoteType = (connection) => [DbtProjectType.DBT, DbtProjectType.DBT_CLOUD_IDE].includes(connection.type);
export const maybeOverrideDbtConnection = (connection, overrides) => {
    // If manifest is provided, create a MANIFEST connection type
    if (overrides.manifest) {
        return {
            type: DbtProjectType.MANIFEST,
            manifest: overrides.manifest,
            hideRefreshButton: true,
        };
    }
    return {
        ...connection,
        ...(isGitProjectType(connection) && overrides.branch
            ? { branch: overrides.branch }
            : undefined),
        ...(!isRemoteType(connection) && overrides.environment
            ? { environment: overrides.environment }
            : undefined),
    };
};
//# sourceMappingURL=projects.js.map